<div class="fixed-top navbar-box d-select " id="navbar" [ngClass]="isShow?'sticky':''"  >
    <div class="navbar-w">
    <div class="d-flex justify-content-between" *ngIf="PageType == PgType.home">
        <a routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" [routerLink]="['/home']">
            <img src="{{imgSrc}}logo-header.svg" alt="back-arrow" class="img-fluid logo-img">
        </a>
        <div class="d-flex">
        

            <div>
                <div class="need-help">Need help?</div>
                <div class="d-flex">
                    <img src="{{imgSrc}}email.svg" alt="back-arrow"
                        class="img-fluid call-img">
                    <div class="phone"><a href="mailto:support@creditgenius.co.uk">support&#64;creditgenius.co.uk</a></div>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>
<div class="fixed-top navbar-box new-bg d-select" *ngIf="PageType !== PgType.home">
    <div class="navbar-w">
    <div class="d-flex justify-content-between">
        <a routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" [routerLink]="['/home']">
            <img src="{{imgSrc}}logo-header.svg" alt="back-arrow" class="img-fluid logo-img">
        </a>
        <div class="d-flex margin-02" *ngIf="PageType == PgType.personal">
            <a class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                [routerLink]="['/personal']" [class.disabled]="true">
                <span class="box-deactive" routerLinkActive="box-active">1</span>
                <br>Personal</a>
            <a class="divider-line "></a>
            <a class="divider-line"></a>
            <a class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                [routerLink]="['/address']" [class.disabled]="true">
                <span class="box-deactive" routerLinkActive="box-active">2</span>
                <br> Address</a>
            <a class="divider-line"></a>
            <a class="divider-line margin-01"></a>
            <a class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                [routerLink]="['/financial']" [class.disabled]="true">
                <span class="box-deactive" routerLinkActive="box-active">3</span>
                <br> Family & Income</a>
        </div>
        <div class="d-flex margin-02" *ngIf="PageType == PgType.address">
            <a class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                [routerLink]="['/personal']" [class.disabled]="true">
                <span class="box-deactive" routerLinkActive="box-active">1</span>
                <br>Personal</a>
            <a class="divider-line "></a>
            <a class="divider-line"></a>
            <a class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                [routerLink]="['/address']" [class.disabled]="true">
                <span class="box-deactive" routerLinkActive="box-active">2</span>
                <br> Address</a>
            <a class="divider-line"></a>
            <a class="divider-line margin-01"></a>
            <a class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                [routerLink]="['/financial']" [class.disabled]="true">
                <span class="box-deactive" routerLinkActive="box-active">3</span>
                <br> Family & Income</a>
        </div>
        <div class="d-flex margin-02" *ngIf="PageType == PgType.family">
            <a class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                [routerLink]="['/personal']" [class.disabled]="true">
                <span class="box-deactive" routerLinkActive="box-active">1</span>
                <br>Personal</a>
            <a class="divider-line "></a>
            <a class="divider-line"></a>
            <a class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                [routerLink]="['/address']" [class.disabled]="true">
                <span class="box-deactive" routerLinkActive="box-active">2</span>
                <br> Address</a>
            <a class="divider-line"></a>
            <a class="divider-line margin-01"></a>
            <a class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                [routerLink]="['/financial']" [class.disabled]="true">
                <span class="box-deactive" routerLinkActive="box-active">3</span>
                <br> Family & Income</a>
        </div>
        <div class="d-flex">

            <div>
                <div class="need-help">Need help?</div>
                <div class="d-flex">
                    <img src="{{imgSrc}}email.svg" alt="back-arrow"
                        class="img-fluid call-img">
                    <div class="phone"><a href="mailto:support@creditgenius.co.uk" >support&#64;creditgenius.co.uk</a></div>
                </div>
            </div>
        </div>
    </div></div>
</div>


<nav class="navbar navbar-expand-lg d-mobile">
    <div class="container-fluid">
        <a routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" [routerLink]="['/home']">
            <img src="{{imgSrc}}logo-header.svg" alt="back-arrow" class="img-fluid logo-img">
        </a>
       
        <div class="text-rt" *ngIf="PageType == PgType.personal">
            <img src="{{imgSrc}}personal-img.svg" alt="back-arrow" class="img-fluid">
            <div class="phone">Personal</div>
        </div>
        <div class="text-rt" *ngIf="PageType == PgType.address">
            <img src="{{imgSrc}}step-address.svg" alt="back-arrow" class="img-fluid">
            <div class="phone">Address</div>
        </div>
        <div class="text-rt" *ngIf="PageType == PgType.family">
            <img src="{{imgSrc}}family-step.svg" alt="back-arrow" class="img-fluid">
            <div class="phone">Family & Income</div>
        </div>
    </div>
</nav>
